import {AbstractModel, DateConverter, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {ProductionPlanningPost} from './production-planning-post';

@JsonObject('model.ProductionPlanningWeek')
export class ProductionPlanningWeek extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(DateConverter, 'startDate')
  startDate?: Date;

  @JsonProperty(Number, 'capacity')
  capacity: number;

  @JsonProperty(ProductionPlanningPost, 'productionPost')
  productionPost: ProductionPlanningPost;

  period: string;

}
